// @ts-nocheck
import React from 'react'

import { Box } from 'components/layout/Box/Box'
import { Table } from 'components/shared/Table/Table'

import styles from './PhoneCell.module.scss'

export const PhoneCell = ({ phone, hasIncreasedHeight }) => (
  <Table.Cell type="body" {...{ hasIncreasedHeight }}>
    <Box
      align="center"
      className={styles.content}
      justify="center"
      tagName="span"
    >
      {phone}
    </Box>
  </Table.Cell>
)
